export default __webpack_public_path__ + "static/media/Bolts of the Armsmaster.94425368.jpg";